module.exports = __webpack_public_path__ + "static/media/file_1709117634082.3ca66c76.eps";